import { createFileRoute, redirect } from '@tanstack/react-router';

/** Section index — counts-first ruling, 2026-08-24: Howick has no silos, so
 * landing operators on the (empty, for Howick) silo status overview is wrong.
 * Redirects every tenant straight to the stock-counts register; the silo
 * status overview moved to its own explicit path, `./status`. */
export const Route = createFileRoute('/_authenticated/silo-counts/')({
  beforeLoad: () => {
    throw redirect({ to: '/silo-counts/counts' });
  },
});
